<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <rest-form
      ref="form"
      :save-endpoint="saveEndpoint"
      :model="model"
      :disabled="readonly"
      v-if="model"
    >
      <form-section
        :title="$t('UrlTracking_Channels_Title')"
        :description="$t('UrlTracking_Channels_Description')"
        data-qa="url-tracking-section"
      >
        <template slot="controls">
          <save-button :click="save" />
        </template>

        <el-row>
          <el-col :span="12">
            <url-tracking-channels :model="model.channels" />
          </el-col>
        </el-row>
      </form-section>

      <form-section
        :title="$t('UrlTracking_UrlParams_Title')"
        :description="$t('UrlTracking_UrlParams_Description')"
        data-qa="url-parameters-section"
      >
        <el-row>
          <el-col :span="12">
            <url-tracking-parameters
              :model="model"
              :disabled="!isActiveChannels"
            />
          </el-col>
        </el-row>
      </form-section>
    </rest-form>
  </rest-page>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import UrlTrackingChannels from '@/modules/settings/components/UrlTrackingChannels'
import UrlTrackingParameters from '@/modules/settings/components/UrlTrackingParameters'
import { projectEndpoint } from '@/core/helpers'
import RestPage from '@/common/components/rest/RestPage'
import RestForm from '@/common/components/rest/RestForm'
import SaveButton from '@/common/components/form/SaveButton'

export default {
  name: 'UrlTrackingTab',

  components: {
    SaveButton,
    RestForm,
    RestPage,
    FormSection,
    UrlTrackingChannels,
    UrlTrackingParameters
  },

  data() {
    return {
      model: null,
      customParamsSwitch: 0
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `url-tracking`,
        handler: data => {
          console.log(data)
          if (data[0]) {
            this.model = {
              ...data[0],
              use_custom_params: data[0].params && data[0].params.length ? 1 : 0
            }
          } else {
            this.model = {
              params: [],
              channels: {},
              utm_params: 0,
              use_custom_params: 0
            }
          }
        }
      })
    },

    saveEndpoint() {
      if (this.model && this.model.id) {
        return projectEndpoint({
          method: 'patch',
          url: `url-tracking/${this.model.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `url-tracking`
        })
      }
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    },

    isActiveChannels() {
      return Object.values(this.model.channels).indexOf(1) !== -1
    }
  },

  methods: {
    save() {
      if (this.model.params) {
        let lastParam = this.model.params[this.model.params.length - 1]
        if (lastParam && lastParam.key === '' && lastParam.value === '') {
          this.model.params.pop()
        }
      }

      this.$nextTick(() => {
        this.$refs['form'].save().then(model => {
          this.model = {
            ...model,
            use_custom_params: model.params && model.params.length ? 1 : 0
          }
        })
      })
    }
  },

  watch: {
    'model.use_custom_params': {
      handler(val) {
        if (val === 0) {
          this.model.params = []
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/UrlTrackingTab.vue